export default __webpack_public_path__ + "static/media/thumbnail.72737c16.png";